import UserManagement from 'components/MapoAdministration/components/User/UserManagement';

const ScreenUserManagement = () => {
  return <UserManagement />;
};

export default ScreenUserManagement;
